import { Helmet } from '@dr.pogodin/react-helmet'
import { Box, Button, Container, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useEffect } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { staticPath } from '@/config'
import gtm from '@/lib/gtm'

const PermissionRequired = () => {
    const theme = useTheme()
    const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'))

    useEffect(() => {
        gtm.push({ event: 'page_view' })
    }, [])

    return (
        <>
            <Helmet>
                <title>Error: Permission Required</title>
            </Helmet>
            <Box
                sx={{
                    alignItems: 'center',
                    // backgroundColor: 'background.paper',
                    display: 'flex',
                    minHeight: '100%',
                    px: 3,
                    py: '80px'
                }}
            >
                <Container maxWidth="lg">
                    <Typography
                        align="center"
                        color="textPrimary"
                        variant={mobileDevice ? 'h4' : 'h1'}
                    >
                        403: Permission required
                    </Typography>
                    <Typography
                        align="center"
                        color="textSecondary"
                        sx={{ mt: 0.5 }}
                        variant="subtitle2"
                    >
                        You do not have permission to do that.
                    </Typography>
                    {/* <Box */}
                    {/*    sx={{ */}
                    {/*        display       : 'flex', */}
                    {/*        justifyContent: 'center', */}
                    {/*        mt            : 6 */}
                    {/*    }} */}
                    {/* > */}
                    {/*    <Box */}
                    {/*        alt="Under development" */}
                    {/*        component="img" */}
                    {/*        src={`${staticPath}/static/error/error403_${theme.palette.mode}.svg`} */}
                    {/*        sx={{ */}
                    {/*            height  : 'auto', */}
                    {/*            maxWidth: '100%', */}
                    {/*            width   : 400 */}
                    {/*        }} */}
                    {/*    /> */}
                    {/* </Box> */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 6
                        }}
                    >
                        <Button
                            color="primary"
                            component={RouterLink}
                            to="/"
                            variant="outlined"
                        >
                            Back to Home
                        </Button>
                    </Box>
                </Container>
            </Box>
        </>
    )
}

export default PermissionRequired
